export default function AboutSection() {
  return (
    <section className="py-10 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-5xl">
          <p className="text-sm text-gray-600 leading-relaxed mb-4">
            Based in Lahore, flightfare.pk is your go-to destination for hassle-free travel planning.
            From hunting down the best flight deals to organising custom tour packages and hotel stays,
            our experienced team handles every aspect of your trip so you never have to worry about
            the details.
          </p>
          <p className="text-sm text-gray-600 leading-relaxed mb-4">
            Our services cover everything from domestic getaways to full international itineraries,
            all crafted around what matters most to you. We also offer reliable travel insurance so
            you are protected no matter what comes up along the way. And for those embarking on the
            sacred journey of Umrah, we have purpose-built packages designed to make every step
            smooth and spiritually rewarding.
          </p>
          <p className="text-sm text-gray-600 leading-relaxed">
            At flightfare.pk, getting you where you need to go — comfortably and affordably — is what
            drives us. Hand the planning over to us and spend your energy on what actually matters:
            enjoying the journey and collecting moments worth remembering.
          </p>
        </div>
      </div>
    </section>
  );
}
